import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="head-container">
            <h1><i>Deshi Bites Food-BD</i></h1>
            <h3><i>TOTAL FOOD BUDGET : 100 MILLION</i></h3>
        </div>
    );
};

export default Header;